import { Component, inject, output } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { map, startWith } from 'rxjs'

import type { OrganizationFilterItem } from '../../../../../services/organization/organization.service'
import { OrganizationService } from '../../../../../services/organization/organization.service'
import { FilterEntitiesDropdown } from '../components/filter-entities-dropdown'

@Component({
  selector: 'dhp-organization-dropdown-filter',
  templateUrl: './organization-dropdown-filter.html',
  imports: [FilterEntitiesDropdown],
})
export class OrganizationDropdownFilter {
  //region Services
  // Inject the organizationService using dependency injection.
  private readonly organizationService = inject(OrganizationService)
  //endregion Services

  //region Outputs
  // The id's of the organizations to filter on.
  protected selectedOrganizationId = output<number | null>()
  //endregion Outputs

  //region Properties
  // The name of the filter.
  protected filterName = 'common.filter.entities.organizations'
  // The organizations that can be selected in the filter dialog.
  protected readonly organizationItems = toSignal(
    this.organizationService.getOrganizationFilterItemsWithSelf().pipe(
      // ensure initial value so template can render deterministically
      startWith(new Set<OrganizationFilterItem>()),
      map(items => items ?? new Set<OrganizationFilterItem>())
    ),
    { initialValue: new Set<OrganizationFilterItem>() }
  )

  //endregion Properties

  // no constructor needed
}
